import React from "react";

import { ButtonStandard, Text } from "@performyard/py-components";

import FormModal from "../../../../components/Modal/Templates/FormModal";

const ConfirmDeleteReviewModal = ({
	isOpen,
	isPending,
	handleClose,
	onSubmit,
}: {
	isOpen: boolean;
	isPending: boolean;
	handleClose: () => void;
	onSubmit: () => void;
}) => {
	return (
		<FormModal
			isOpen={isOpen}
			handleClose={handleClose}
			onSubmit={async (e) => {
				// Don't reload the page
				e.preventDefault();

				onSubmit();
			}}
			wrapperClassName="max-w-[400px]"
			title={
				<Text weight="semi-bold" size="sub-heading">
					Delete Review
				</Text>
			}
			buttons={[
				<div key="cancel">
					<ButtonStandard size="large" onClick={handleClose}>
						<Text size="paragraph-1">Cancel</Text>
					</ButtonStandard>
				</div>,
				<div key="save">
					<ButtonStandard size="large" disabled={isPending} color="red" type="submit">
						<Text size="paragraph-1">Yes, Delete Review</Text>
					</ButtonStandard>
				</div>,
			]}
		>
			<Text size="paragraph-1" weight="regular" dangerouslySetClassName="text-center">
				Are you sure you want to delete this review? This action is permanent and cannot be undone.
			</Text>
		</FormModal>
	);
};

export default ConfirmDeleteReviewModal;
